module.exports = __webpack_public_path__ + "assets/img/kailash.a08afe7f.jpg";